import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 24 24">
      <path d="M11 12C11 11.4477 11.4477 11 12 11H20C20.5523 11 21 11.4477 21 12V20C21 20.5523 20.5523 21 20 21H12C11.4477 21 11 20.5523 11 20V12Z"/>
      <path d="M19 3C20.1046 3 21 3.89543 21 5H19V3Z"/>
      <path d="M5 21C3.89543 21 3 20.1046 3 19H5V21Z"/>
      <path d="M3 15H5V17H3V15Z"/>
      <path d="M7 19H9V21H7V19Z"/>
      <path d="M3 11H5V13H3V11Z"/>
      <path d="M3 7H5V9H3V7Z"/>
      <path d="M15 3H17V5H15V3Z"/>
      <path d="M19 7H21V9H19V7Z"/>
      <path d="M11 3H13V5H11V3Z"/>
      <path d="M7 3H9V5H7V3Z"/>
      <path d="M3 5C3 3.89543 3.89543 3 5 3V5H3Z"/>
    </CommonSVGIcon>
  );
}
